import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = {
    [t("footer_sec1")]: [
      { labelKey: "footer_l1_1", href: "#accounting-services" },
      { labelKey: "footer_l1_2", href: "#taxation-services" },
      { labelKey: "footer_l1_3", href: "#mpf-services" },
      { labelKey: "footer_l1_4", href: "#about" },
    ],
    [t("footer_sec2")]: [
      { labelKey: "footer_l2_1", href: "#about" },
      { labelKey: "footer_l2_2", href: "#about" },
      { labelKey: "footer_l2_3", href: "#about" },
      { labelKey: "footer_l2_4", href: "#contact" },
    ],
  };

  const handleNav = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#FDF2EE] border-t border-[#F0D5CB]">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/4f9f6a64cb84e58f95d0a42c8c0ffa57/f3822a50bf426e713c09d7fc92b2de01.jpeg"
                alt="Nice Accounting Logo"
                className="h-10 w-auto object-contain"
              />
              <span className="font-bold text-lg text-[#1C2331]">Nice Accounting</span>
            </div>
            <p className="text-[#6B7280] text-sm leading-relaxed max-w-xs mb-5">
              {t("footer_desc")}
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-[#6B7280] text-xs">
                <i className="ri-phone-line text-[#D4927A]" />
                {t("footer_phone")}
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h5 className="font-bold text-[#1C2331] text-sm mb-4">{section}</h5>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.labelKey}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                      className="text-[#6B7280] text-xs hover:text-[#D4927A] transition-colors cursor-pointer"
                    >
                      {t(link.labelKey)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#F0D5CB] px-6 py-5">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#9CA3AF] text-xs">
            &copy; {new Date().getFullYear()} {t("footer_copy")}
          </p>
          <div className="flex items-center gap-2">
            <span className="text-[#9CA3AF] text-xs">{t("footer_privacy")}</span>
            <span className="text-[#9CA3AF] text-xs">|</span>
            <span className="text-[#9CA3AF] text-xs">{t("footer_terms")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
